import { useContext, useMemo, useState } from 'react'
import { useGlobalEnvConfig } from "@environment/GlobalEnvConfigProvider";
import { Trans } from '@lingui/macro';

import { BasicData } from '@App';
import { safeImageUrl, checkBrandingType, getTextColorClass, getColor } from '@utils/Utils';
import avatar from '@/assets/images/avatar.svg';

import './style.scss';
import { useScrollPosition } from '@utils/hooks/useScrollPosition';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faEnvelope, faGlobe, faPhone, faXmark } from '@fortawesome/pro-regular-svg-icons';

const Contact = () => {
    const { REACT_APP_RESOURCE_DOMAIN } = useGlobalEnvConfig();
    const { contact_detail, type, theme, emergency_contact, emergency_contact_name, is_using_new_overrides, contact_detail_type, contact_image_type } = useContext(BasicData);
    const [showDetails, setShowDetails] = useState(false);
    const [top, setTop] = useState(true);

    const colors = getColor(theme);

    const imageSource = useMemo(() => {
        if (!is_using_new_overrides) {
            if (contact_detail?.is_identity_branded) {
                if (contact_detail?.logo_url_fragment) {
                    return safeImageUrl(REACT_APP_RESOURCE_DOMAIN,`${contact_detail.logo_url_fragment}`, 100, 100, "", "?fmt=png");
                }
                return avatar;
            } else {
                const brandingType = checkBrandingType(theme, type);
                if (brandingType === "consultant") {
                    if (contact_detail?.consultant_photo_url_fragment) {
                        return safeImageUrl(REACT_APP_RESOURCE_DOMAIN,`${contact_detail.consultant_photo_url_fragment}`, 100, 100, "", "?fmt=png");
                    } else {
                        return avatar;
                    }
                } else {
                    if (contact_detail?.logo_url_fragment) {
                        return safeImageUrl(REACT_APP_RESOURCE_DOMAIN,`${contact_detail.logo_url_fragment}`, 100, 100, "", "?fmt=png")
                    } else {
                        return avatar;
                    }
                }
            }
        } else {
            switch (contact_image_type) {
                case "Operator":
                    if (contact_detail?.logo_url_fragment) {
                        return safeImageUrl(REACT_APP_RESOURCE_DOMAIN,`${contact_detail.logo_url_fragment}`, 100, 100, "", "?fmt=png")
                    } else {
                        return avatar;
                    }
                case "OperatorUser":
                    if (contact_detail?.consultant_photo_url_fragment) {
                        return safeImageUrl(REACT_APP_RESOURCE_DOMAIN,`${contact_detail.consultant_photo_url_fragment}`, 100, 100, "", "?fmt=png");
                    } else {
                        return avatar;
                    }
                case "OperatorIdentity":
                    if (contact_detail?.logo_url_fragment) {
                        return safeImageUrl(REACT_APP_RESOURCE_DOMAIN,`${contact_detail.logo_url_fragment}`, 100, 100, "", "?fmt=png");
                    }
                    return avatar;
            }
        }
    }, [REACT_APP_RESOURCE_DOMAIN, contact_detail, is_using_new_overrides, contact_detail_type, contact_image_type, type, theme])

    const name = useMemo(() => {
        if (!is_using_new_overrides) {
            if (contact_detail?.is_identity_branded) {
                return contact_detail.company_name;
            } else {
                const brandingType = checkBrandingType(theme, type);
                if (brandingType === "consultant") {
                    return contact_detail?.consultant_name;
                } else {
                    return contact_detail?.company_name;
                }
            }
        } else {
            switch (contact_detail_type) {
                case "Operator":
                    return contact_detail?.company_name;
                case "OperatorUser":
                    return contact_detail?.consultant_name;
                case "OperatorIdentity":
                    return contact_detail?.company_name;
            }
        }
    }, [contact_detail, type, theme])

    const avatarComponent = useMemo(() => {
        return (
            <div className='avatar' onClick={() => setShowDetails(!showDetails)}>
                <img src={imageSource} alt="" />
            </div>
        )
    }, [showDetails, imageSource])

    const detailsComponent = useMemo(() => {
        return (
            <div className={showDetails ? 'avatar-details-wrapper show' : 'avatar-details-wrapper'}>
                <div className='close' onClick={() => setShowDetails(false)}><FontAwesomeIcon icon={faXmark} /></div>
                <div className='avatar-details'>
                    <h6><Trans>Connect with</Trans></h6>
                    <h3>{name}</h3>
                    <div className='avatar-details-container'>
                        {contact_detail?.phone && (
                            <div className='avatar-details-row'>
                                <FontAwesomeIcon icon={faPhone} className={getTextColorClass(colors?.primary)} />
                                <p><a href={`tel:${contact_detail.phone}`}>{contact_detail.phone}</a></p>
                            </div>
                        )}

                        {contact_detail?.email && (
                            <div className='avatar-details-row'>
                                <FontAwesomeIcon icon={faEnvelope} className={getTextColorClass(colors?.primary)} />
                                <p><a href={`mailto:${contact_detail.email}`}>{contact_detail.email}</a></p>
                            </div>
                        )}

                        {contact_detail?.website && (
                            <div className='avatar-details-row'>
                                <FontAwesomeIcon icon={faGlobe} className={getTextColorClass(colors?.primary)} />
                                <p><a target='blank' href={contact_detail.website}>{contact_detail.website}</a></p>
                            </div>
                        )}
                    </div>

                    {emergency_contact && (
                        <div className='avatar-details-row'>
                            <FontAwesomeIcon icon={faCircleInfo} className={getTextColorClass(colors?.primary)} />
                            <p>
                                {emergency_contact_name ? `${emergency_contact_name} - ` : ''}
                                <Trans>Emergency Contact</Trans>: <br /> {emergency_contact}
                            </p>
                        </div>
                    )}

                </div>
            </div>
        )
    }, [contact_detail, showDetails, name, emergency_contact, emergency_contact_name, colors?.primary])

    useScrollPosition(({ currPos }) => {
        if (currPos.y > 0) {
            setTop(false)
        } else {
            setTop(true)
        }

    }, [top], null, true)

    return (
        <div className={`floating-contact${top ? ' is-top' : ''}`}>
            {avatarComponent}
            {detailsComponent}
        </div>
    )
}

export default Contact